import dayjsLib from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";

dayjsLib.extend(relativeTime);
dayjsLib.extend(LocalizedFormat);

export const dayjs = dayjsLib;
